import React from 'react';
import { MDBBtnFixedItem, MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import RecruitCard from './ComponentFragments/RecruitCard';


export default class Recruiting extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            recruitData: [],
            filteredData: []
        }
        this.searchList = this.searchList.bind(this);
        this.props.loaderOff();
    }

    searchList(phrase) {
        let arr = [];
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        arr = this.state.recruitData.filter((dem) => (dem.recruiter.toUpperCase().includes(phrase.toUpperCase())) || (dem.recruitName.toUpperCase().includes(phrase.toUpperCase())) || (dem.unitName.toUpperCase().includes(phrase.toUpperCase())))
        this.setState({ filteredData: arr });
    }

    async componentWillMount() {
        var dl = new DataLayer();
        await dl.Get('/common/getrecruits', 200).then((response) => {
            this.setState({
                recruitData: response.data,
                filteredData: response.data
            });
            this.props.loaderOff();
        })
    }

    
    render() {
        let headerText = "New Recruits";
        return (
            <div>
                <Header headerText={headerText}
                    placeholderText="Search Recruits"
                    searchList={this.searchList}
                />
                <MDBRow>
                    {
                        this.state.filteredData.map((dem) => {
                            var ttt = "";
                            return (
                                <MDBCol xl="3" lg="3" md="4" sm="12" className="mb-r" >
                                    <RecruitCard
                                        recruitName={dem.recruitName.toUpperCase()}
                                        sfCurrentCode={dem.sfCurrentCode}
                                        segmentSales={dem.segmentSales}
                                        currentWeekSales={dem.currentWeekSales}
                                        recruitedWeek={dem.recruitedWeek}
                                        recruiter={dem.recruiter}
                                        unitName={dem.unitName}
                                        telephoneCell={dem.telephoneCell}
                                        qualified={dem.qualified}
                                    />
                                </MDBCol>


                            );
                        })
                    }
                </MDBRow>


            </div>
        );
    }
}